import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export enum ServiceName {
  SignalR = 'SignalR',
  Menu = 'Menu',
  Config = 'Config',
  Language = "Language",
}

@Injectable({
  providedIn: 'root'
})
export class ServiceReadyStateService {
  private requiredServices: ServiceName[] = [
    ServiceName.SignalR,
    ServiceName.Menu,
    ServiceName.Config,
    ServiceName.Language,
  ];

  private servicesStatus: Map<ServiceName, BehaviorSubject<boolean>> = new Map();
  private allServicesReadySubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {
    // Initialize BehaviorSubjects for each service
    this.requiredServices.forEach(service => {
      this.servicesStatus.set(service, new BehaviorSubject<boolean>(false));
    });
  }

  // Set a service's ready state
  setServiceReady(serviceName: ServiceName, isReady: boolean): void {
    let serviceSubject = this.servicesStatus.get(serviceName);
    if (!serviceSubject) {
      serviceSubject = new BehaviorSubject<boolean>(false);
      this.servicesStatus.set(serviceName, serviceSubject);
    }
    serviceSubject.next(isReady);
    this.checkAllServicesReady();
  }

  // Check if all services are ready
  private checkAllServicesReady(): void {
    const allReady = this.requiredServices.every(
      serviceName => this.servicesStatus.get(serviceName)?.value === true
    );
    this.allServicesReadySubject.next(allReady);
  }

  // Observable for all services ready state
  get allServicesReady$(): Observable<boolean> {
    return this.allServicesReadySubject.asObservable();
  }

  // Get an Observable for a specific service's ready state
  isServiceReady(serviceName: ServiceName): Observable<boolean> {
    if (!this.servicesStatus.has(serviceName)) {
      this.servicesStatus.set(serviceName, new BehaviorSubject<boolean>(false));
    }
    return this.servicesStatus.get(serviceName)!.asObservable();
  }
}